var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('jdi-content',{attrs:{"title":"Candidate Bubble","docs":require('@/../metadata/JdsCandidateBubble.json')}},[_c('jdi-docs',{attrs:{"docs":require('@/../metadata/JdsCandidateBubble.json')}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }